module.exports = __webpack_public_path__ + "static/media/scan4.6a929d48.png";